module.exports = __webpack_public_path__ + "img/icon-piggy-bank.94f651eb.svg";